// Regex Patterns
export const REGEX_PATTERNS = {
  // Name validations
  FULL_NAME:/^[A-Za-z\s]+$/,
  FIRST_NAME: /^[a-zA-Z'-]+$/,
  LAST_NAME: /^[a-zA-Z'-]+$/,
  
  // Email validation
  EMAIL: /^[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]{0,62}[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,62}[a-zA-Z0-9])?(?:.[a-zA-Z]{2,})+$/,
  
  // Phone validations
  PHONE_10_DIGIT: /^\d{10}$/,
  PHONE_WITH_CODE: /^\+?[1-9]\d{1,14}$/,
  
  // Password validations
  PASSWORD_STRONG: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  PASSWORD_MEDIUM: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{6,}$/,
  
  // Address/Text
  ALPHANUMERIC: /^[a-zA-Z0-9\s]+$/,
  ALPHANUMERIC_SPECIAL: /^[a-zA-Z0-9\s.,'-]+$/,
  
  // Numbers
  NUMBERS_ONLY: /^\d+$/,
  DECIMAL: /^\d+(\.\d{1,2})?$/,
  
  // URLs
  URL: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
  
  // ZIP/Postal codes
  ZIP_CODE_US: /^\d{5}(-\d{4})?$/,
  PINCODE_INDIA: /^\d{6}$/,
  
  // Others
  USERNAME: /^[a-zA-Z0-9_]{3,20}$/,
  GST_NUMBER: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
};

// Validation Rule Templates
export const VALIDATION_RULES = {
  // Name fields
  full_name: {
    required: "Full Name is required",
    pattern: {
      regex: REGEX_PATTERNS.FULL_NAME,
      message: "Full name must be valid",
    },
    minLength: { value: 2, message: "Full name must be at least 2 characters" },
    maxLength: { value: 50, message: "Full name cannot exceed 50 characters" },
  },
  
  first_name: {
    required: "First Name is required",
    pattern: {
      regex: REGEX_PATTERNS.FIRST_NAME,
      message: "First name can only contain letters, hyphens, and apostrophes",
    },
    minLength: { value: 2, message: "First name must be at least 2 characters" },
  },
  
  last_name: {
    required: "Last Name is required",
    pattern: {
      regex: REGEX_PATTERNS.LAST_NAME,
      message: "Last name can only contain letters, hyphens, and apostrophes",
    },
  },
  
  // Email
  email: {
    required: "Email is required",
    pattern: {
      regex: REGEX_PATTERNS.EMAIL,
      message: "Invalid email format",
    },
  },
  
  // Phone
  phone: {
    required: false,
    validate: (value) => {
      if (!value.trim()) return true;
      const digits = value.replace(/\D/g, "");
      if (digits.length < 10) return "Phone number must be exactly 10 digits";
      if (digits.length > 10) return "Phone number cannot be more than 10 digits";
      return true;
    },
  },
  
  phone_required: {
    required: "Phone number is required",
    validate: (value) => {
      const digits = value.replace(/\D/g, "");
      if (digits.length !== 10) return "Phone number must be exactly 10 digits";
      return true;
    },
  },
  
  // Password
  password: {
    required: "Password is required",
    pattern: {
      regex: REGEX_PATTERNS.PASSWORD_MEDIUM,
      message: "Password must contain at least 6 characters, one uppercase, one lowercase, and one number",
    },
  },
  
  password_strong: {
    required: "Password is required",
    pattern: {
      regex: REGEX_PATTERNS.PASSWORD_STRONG,
      message: "Password must be at least 8 characters with uppercase, lowercase, number, and special character",
    },
  },
  
  confirm_password: {
    required: "Please confirm your password",
    matchField: "password", // Special rule to match another field
  },
  
  // Message/Textarea
  message: {
    required: "Message is required",
    custom: (value) => {
      if (!value.trim()) return "Message is required";
      if (value.length < 10) return "Message must be at least 10 characters";
      if (value.length > 500) return "Message must be under 500 characters";
      return "";
    },
  },
  
  short_message: {
    required: "Message is required",
    minLength: { value: 10, message: "Message must be at least 10 characters" },
    maxLength: { value: 200, message: "Message must be under 200 characters" },
  },
  
  // Dropdown/Select
  requirement: {
    required: "Please select a requirement",
  },
  
  category: {
    required: "Please select a category",
  },
  
  // URL
  website: {
    required: false,
    pattern: {
      regex: REGEX_PATTERNS.URL,
      message: "Please enter a valid URL",
    },
  },
  
  // Number fields
  age: {
    required: "Age is required",
    pattern: {
      regex: REGEX_PATTERNS.NUMBERS_ONLY,
      message: "Age must be a number",
    },
    custom: (value) => {
      const age = parseInt(value);
      if (age < 18) return "You must be at least 18 years old";
      if (age > 120) return "Please enter a valid age";
      return "";
    },
  },
  
  // ZIP/Pincode
  pincode: {
    required: "Pincode is required",
    pattern: {
      regex: REGEX_PATTERNS.PINCODE_INDIA,
      message: "Pincode must be 6 digits",
    },
  },
  
  // Address
  address: {
    required: "Address is required",
    pattern: {
      regex: REGEX_PATTERNS.ALPHANUMERIC_SPECIAL,
      message: "Address contains invalid characters",
    },
    minLength: { value: 10, message: "Address must be at least 10 characters" },
  },
  
  // Company name
  company_name: {
    required: "Company name is required",
    pattern: {
      regex: REGEX_PATTERNS.ALPHANUMERIC_SPECIAL,
      message: "Company name contains invalid characters",
    },
  },
};
